import { Box, Flex } from '@chakra-ui/react';

import { TextRegular, TextSemiBold } from 'UiKit/typography';
import InputComponent from 'UiKit/input';
import ButtonOutline from 'UiKit/button/buttonOutline';
import ButtonSolid from 'UiKit/button/buttonSolid';

import { NOTE_MAX_LENGTH } from '../const';

import styles from './styles.module.css';

const ProductItemEditPanel = ({ noteValue, savedNote, setNoteValue, onSave, onCancel, t }) => (
  <Box className={styles['product-item__edit']}>
    <InputComponent
      placeholder={t('formTalkingPoint.notes')}
      value={noteValue}
      onChange={(value) => setNoteValue(value.slice(0, NOTE_MAX_LENGTH))}
      className={styles['product-item__note-input']}
    />
    <TextRegular className={styles['product-item__char-counter']}>
      ({noteValue.length}/{NOTE_MAX_LENGTH})
    </TextRegular>
    <Flex className={styles['product-item__edit-actions']}>
      <ButtonOutline height="28px" padding="6px 12px" borderRadius="var(--radius-sm)" type="button" onClick={onCancel}>
        <TextSemiBold fontSize="var(--font-body2)">{t('formTalkingPoint.cancelButton')}</TextSemiBold>
      </ButtonOutline>
      <ButtonSolid height="28px" padding="6px 12px" borderRadius="var(--radius-sm)" type="button" isDisabled={noteValue === savedNote} onClick={onSave}>
        <TextSemiBold fontSize="var(--font-body2)" color="white">
          {t('formTalkingPoint.saveButton')}
        </TextSemiBold>
      </ButtonSolid>
    </Flex>
  </Box>
);

export default ProductItemEditPanel;
